// Universal Chart Controls state initialization

// eslint-disable-next-line import/prefer-default-export
export function init({
  granularity = 'daily',
  chartMetrics: { primaryMetric = {}, secondaryMetric = {} } = {},
  chartSettings: { metricView, appearance } = {},
} = {}) {
  return {
    granularity,
    chartMetrics: {
      primaryMetric: {
        metric: primaryMetric.metric,
        chartType: primaryMetric.chartType || 'spline',
      },
      secondaryMetric: {
        metric: secondaryMetric.metric,
        chartType: secondaryMetric.chartType || 'spline',
      },
    },
    chartSettings: {
      metricView,
      appearance: appearance || [],
    },
  };
}

// Examples of structures

// const defaultsControls = {
//   granularity: 'daily' | undefined,
//   chartMetrics: {
//     primaryMetric: {
//       metric: 'revenue',
//       chartType: 'line' | undefined,
//     },
//     secondaryMetric: {
//       metric: 'downloads' | undefined,
//       chartType: 'column' | undefined,
//     },
//   },
//   chartSettings: {
//     metricView: undefined | 'Type of metric view',
//     appearance: [
//       'stacked', 'verticalGridlines', 'horizontalGridlines', 'highlightWeekends',
//     ] | undefined,
//   },
// };

// const controlsConfig = {
//   granularity: {
//     tooltip: 'Granularity tooltip' | undefined,
//     disabled: true | undefined,
//     enableOptions: ['daily', 'weekly', 'monthly', 'quarterly', 'yearly'] | undefined,
//   },
//   chartMetrics: {
//     primaryMetric: {
//       metrics: [{
//         value: 'revenue',
//         text: 'Revenue',
//         disabled: false,
//         tooltip: undefined,
//       }],
//       chartTypes: ['line', 'column', 'areaspline'] | undefined,
//     },
//     secondaryMetric: {
//       metrics: [{
//         value: 'downloads',
//         text: 'Downloads',
//         disabled: false,
//         tooltip: undefined,
//         hidden: true, // Ability to hide item from metric list when displaying
//         showcase: <p>Store Dls</p> // Ability to display dropdown button text in a different way.
//       }],
//       chartTypes: ['line', 'column', 'areaspline'] | undefined,
//     },
//   },
//   chartSettings: {
//     tooltip: 'Chart settings tooltip' | undefined,
//     disabled: true | undefined,
//     metricView: {
//       views: [{
//         value: 'market_share',
//         text: 'Market Share',
//         disabled: false,
//         tooltip: undefined,
//       }],
//     },
//     appearance: {
//       enableOptions: [
//         'stacked', 'verticalGridlines', 'horizontalGridlines', 'highlightWeekends',
//       ] | undefined,
//       customOptions: [['stacked', 'Stacked custom name'], ...] | undefined,
//     },
//   },
//   chartExport: {
//     tooltip: 'Export tooltip' | undefined,
//     disabled: true | undefined,
//   },
// };

// const disableControls = {
//   granularity: ['daily'] | [{ value: 'daily', tooltip: 'Not available' }] | undefined,
//   chartMetrics: {
//     primaryMetric: {
//       metrics: ['downloads'] | [{ value: 'downloads', tooltip: 'Not available' }] | undefined,
//       chartTypes: ['line'] | [{ value: 'line', tooltip: 'Not available' }] | undefined,
//     },
//     secondaryMetric: {
//       metrics: ['revenue'] | [{ value: 'revenue', tooltip: 'Not available' }] | undefined,
//       chartTypes: ['column'] | [{ value: 'column', tooltip: 'Not available' }] | undefined,
//     },
//   },
//   chartSettings: {
//     metricView: ['market_share'] | [{ value: 'market_share', tooltip: 'Not available' }]
//       | undefined,
//     appearance: ['stacked'] | [{ value: 'stacked', tooltip: 'Not available' }] | undefined,
//   },
// };
